import type {
  UserActivityAnalytics,
  UserActivityAnalyticsQuery,
  UserActivityLive,
  UserActivitySessionLoadRequest,
  UserActivitySummary,
  UserActivitySummaryQuery,
  UserActivitySessionEntry
} from '@jarvis/platform-ui';
import { apiFetch, readJson } from './client';

function toQueryString(params: Record<string, string | number | boolean | undefined>): string {
  const parts = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== '')
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`);
  return parts.length === 0 ? '' : `?${parts.join('&')}`;
}

export async function getClientPortalUserActivityLive(): Promise<UserActivityLive> {
  const res = await apiFetch(`/api/admin/client-portal/user-activity/live`);
  if (!res.ok) throw new Error(`Failed to load client portal live user activity: ${res.status}`);
  return readJson<UserActivityLive>(res);
}

export async function getClientPortalUserActivityAnalytics(
  query: UserActivityAnalyticsQuery = {}
): Promise<UserActivityAnalytics> {
  const res = await apiFetch(
    `/api/admin/client-portal/user-activity/analytics${toQueryString({ ...query })}`
  );
  if (!res.ok) throw new Error(`Failed to load client portal user activity analytics: ${res.status}`);
  return readJson<UserActivityAnalytics>(res);
}

export async function getClientPortalUserActivitySummary(
  query: UserActivitySummaryQuery = {}
): Promise<UserActivitySummary> {
  const res = await apiFetch(
    `/api/admin/client-portal/user-activity/summary${toQueryString({ ...query })}`
  );
  if (!res.ok) throw new Error(`Failed to load client portal user activity summary: ${res.status}`);
  return readJson<UserActivitySummary>(res);
}

export async function listClientPortalUserActivitySessions(
  opts: UserActivitySessionLoadRequest = {}
): Promise<{ total: number; items: UserActivitySessionEntry[] }> {
  const res = await apiFetch(
    `/api/admin/client-portal/user-activity/sessions${toQueryString({ ...opts })}`
  );
  if (!res.ok) throw new Error(`Failed to list client portal user activity sessions: ${res.status}`);
  return readJson<{ total: number; items: UserActivitySessionEntry[] }>(res);
}
